import React, { createContext, useContext, useEffect, useState } from "react";
import { adminMe, getToken, clearToken } from "../lib/adminApi";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = checking session, false = unauthenticated, object = authenticated admin
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!getToken()) {
      setUser(false);
      return;
    }
    adminMe()
      .then(setUser)
      .catch(() => {
        clearToken();
        setUser(false);
      });
  }, []);

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
